import { ProductService } from '@gid/models';

export default {
  methods: {
    limitServiceDefinitionsMixin(
      sourceServiceDefinitions,
      limitedServices: ProductService[],
    ) {
      if (limitedServices && sourceServiceDefinitions) {
        return limitedServices
          .map((limitedService) => {
            return {
              linkType: limitedService.linkType,
              service: sourceServiceDefinitions[limitedService.service?.id],
            };
          })
          .filter((serviceDef) => !!serviceDef.service)
          .reduce(
            (r, e) => ({
              ...r,
              [e.linkType]: [...(r[e.linkType] ?? []), e.service],
            }),
            {},
          );
      }
      return [];
    },
  },
};
